/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 76856110e961b30a13c4443def3a3c70 */

import { ConcreteRequest } from "relay-runtime";
export type InitiateCallInput = {
    buyerId: string;
    buyerName: string;
    buyerNumber: string;
    buyerCountryCode: number;
    dealerId: string;
    itemId?: string | null | undefined;
    itemName?: string | null | undefined;
    saveName?: boolean | null | undefined;
    savePhoneNumber?: boolean | null | undefined;
    phoneCallbackEnabled?: boolean | null | undefined;
    callbackPhoneId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type InitiateCallMutationVariables = {
    input: InitiateCallInput;
};
export type InitiateCallMutationResponse = {
    readonly initiateCall: {
        readonly success: boolean;
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
        } | null> | null;
    } | null;
};
export type InitiateCallMutation = {
    readonly response: InitiateCallMutationResponse;
    readonly variables: InitiateCallMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InitiateCallPayload",
    "kind": "LinkedField",
    "name": "initiateCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InitiateCallMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InitiateCallMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/352.0.0-2022-02-11T22:12:31.273Z/InitiateCallMutation",
    "metadata": {},
    "name": "InitiateCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '53bc9d8798f7475aca3b0a9b059c924d';
export default node;
